export default {
  fields: {
    email: "Электронная почта",
    displayName: "Отображаемое имя",
    password: "Пароль",
    currentPassword: "Текущий пароль",
    newPassword: "Новый пароль",
    confirmPassword: "Повторите пароль",
    resetToken: "Код сброса",
    togglePassword: "Показать или скрыть значение",
  },
  validation: {
    required: "Обязательное поле",
    email: "Введите корректный адрес электронной почты",
    passwordLength: "Используйте не менее 12 символов",
    passwordMatch: "Пароли не совпадают",
  },
  errors: {
    rateLimited: "Слишком много попыток. Повторите позднее.",
    service: "Сервис временно недоступен. Повторите попытку.",
  },
  login: {
    title: "Вход",
    action: "Войти",
    noAccount: "Нет учётной записи?",
    invalid: "Неверная электронная почта или пароль.",
  },
  register: {
    title: "Создание учётной записи",
    action: "Зарегистрироваться",
    hasAccount: "Уже есть учётная запись?",
    failed: "Не удалось завершить регистрацию. Проверьте поля и повторите попытку.",
    accountExists: "Учётная запись с такой электронной почтой уже существует",
  },
  forgot: {
    title: "Восстановление пароля",
    link: "Забыли пароль?",
    description: "Введите почту. Ответ не зависит от наличия учётной записи.",
    action: "Запросить сброс",
    accepted: "Если учётная запись существует, инструкции по сбросу отправлены.",
    back: "Вернуться ко входу",
  },
  reset: {
    title: "Сброс пароля",
    description: "Вставьте одноразовый код из сообщения. Код не сохраняется в адресе страницы.",
    action: "Установить новый пароль",
    invalid: "Код сброса неверен или просрочен.",
    done: "Пароль изменён. Теперь можно войти.",
  },
}
